module.exports = __webpack_public_path__ + "img/KP.a6c8a945.svg";